import React from 'react';
import './ContactUs.scss';
import { useSelector } from 'react-redux';

import contentJson from './ContactUs.json';
import { getLocalizedContent as l } from '@helpers/languages';
import AnalyticsLink from '@components/Analytics/AnalyticsLink';

const ContactUs = () => {
  const {
    appState: { prefixLanguage },
  } = useSelector(state => state);

  return (
    <div className="ContactUs">
      <div className="ContactUs__headerDiv">
        <h2 className="ContactUs__header">
          {l(contentJson.header, prefixLanguage)}
        </h2>
        <div className="ContactUs__subtitle">
          {l(contentJson.subtitle, prefixLanguage)}
        </div>
      </div>
      <ul className="ContactUs__buttonsDiv">
        <AnalyticsLink
          to={`tel: ${l(contentJson.phoneNumberForHref, prefixLanguage)}`}
          className="ContactUs__callUsLink"
        >
          <div>{l(contentJson.phoneNumberText, prefixLanguage)}</div>
          <div>{l(contentJson.phoneNumberDisplay, prefixLanguage)}</div>
        </AnalyticsLink>
        <AnalyticsLink
          to={l(contentJson.link, prefixLanguage)}
          className="ContactUs__sendMessageButton"
        >
          {l(contentJson.sendMessageButton, prefixLanguage)}
        </AnalyticsLink>
      </ul>
    </div>
  );
};

export default ContactUs;
